module.exports = __webpack_public_path__ + "static/header-with-us-e2c7a477405067f8828998836498e42a.jpg";